import React, { ReactNode, useState } from 'react';

interface TooltipProps {
  children: ReactNode;
  title: ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';
  className?: string;
  multiline?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({
  children, title, placement = 'top', className = '', multiline = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const getPlacementClasses = () => {
    switch (placement) {
      case 'top':
        return 'cr-bottom-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-mb-2';
      case 'top-start':
        return 'cr-bottom-full cr-left-0 cr-mb-2';
      case 'top-end':
        return 'cr-bottom-full cr-right-0 cr-mb-2';
      case 'bottom':
        return 'cr-top-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-mt-2';
      case 'bottom-start':
        return 'cr-top-full cr-left-0 cr-mt-2';
      case 'bottom-end':
        return 'cr-top-full cr-right-0 cr-mt-2';
      case 'left':
        return 'cr-right-full cr-top-1/2 cr-transform -cr-translate-y-1/2 cr-mr-2';
      case 'right':
        return 'cr-left-full cr-top-1/2 cr-transform -cr-translate-y-1/2 cr-ml-2';
      default:
        return 'cr-bottom-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-mb-2';
    }
  };

  const getArrowClasses = () => {
    switch (placement) {
      case 'top':
      case 'top-start':
      case 'top-end':
        return 'cr-top-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-border-t-gray-800';
      case 'bottom':
      case 'bottom-start':
      case 'bottom-end':
        return 'cr-bottom-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-border-b-gray-800';
      case 'left':
        return 'cr-left-full cr-top-1/2 cr-transform -cr-translate-y-1/2 cr-border-l-gray-800';
      case 'right':
        return 'cr-right-full cr-top-1/2 cr-transform -cr-translate-y-1/2 cr-border-r-gray-800';
      default:
        return 'cr-top-full cr-left-1/2 cr-transform -cr-translate-x-1/2 cr-border-t-gray-800';
    }
  };

  return (
    <div
      className={`cr-relative cr-inline-block ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`cr-absolute cr-z-50 cr-rounded cr-bg-gray-800 cr-px-2 cr-py-1 cr-text-xs cr-text-white
            cr-shadow-lg ${multiline ? 'cr-whitespace-normal cr-max-w-xs' : 'cr-whitespace-nowrap'}
            ${getPlacementClasses()}`}
        >
          {title}
          <div className={`cr-absolute cr-h-0 cr-w-0 cr-border-4 cr-border-transparent ${getArrowClasses()}`} />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
